import React from 'react';
import { Card, Row, Col, Button } from 'antd';
import { connect } from 'dva';
import { routerRedux } from 'dva/router';
import AddBankCardForm from '../AddBankCardForm/Index.js';

@connect()
export default class AddBankCardSteps extends React.Component {
  constructor(props) {
    super(props);
    this.handleGoBack = this.handleGoBack.bind(this);
    this.handleSaveSuccessCallback = this.handleSaveSuccessCallback.bind(this);
  }

  componentWillUnmount() {
    this.props.dispatch({ type: 'merchantBusinessAddBankCard/resetState' });
  }

  handleGoBack() {
    this.props.dispatch(routerRedux.goBack());
  }

  handleSaveSuccessCallback() {
    if (this.props.saveSuccessCallback) {
      this.props.saveSuccessCallback();
    }
  }

  render() {
    return (
      <Card bordered={false}>
        <Row>
          <Col span={24}>
            <AddBankCardForm
              type="add"
              extraActions={<Button onClick={this.handleGoBack}>返回</Button>}
              saveSuccessCallback={this.handleSaveSuccessCallback}
            />
          </Col>
        </Row>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Merchant/Business/components/AddBankCardSteps/Index.js